import React, { useState } from 'react';
import { connect } from 'react-redux';

import { INVOICE, invoiceEnumTransKey } from '../enums';

import { Container } from '../styles';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import CheckboxControl from '../../../../Tracking/components/NFFilters/components/CheckboxControl';

const label = Object.values(INVOICE);

const Invoice = ({ isOpen, onClick, onApply, nfType }) => {
  const [selectedItem, setSelectedItem] = useState(nfType);
  
  const handleChange = e => {
    const { value } = e.target;
    setSelectedItem(value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem('');
    onApply('');
  };

  return (
    <FilterContainer label="Tipo de nota" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por tipo de nota"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              checked={selectedItem === filter.toString()}
              label={invoiceEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  nfType: state.carbon.filters.nfType,
});

export default connect(mapStateToProps)(Invoice);
